export default {
  DepartmentCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
